module.exports = __webpack_public_path__ + "assets/img/slat_open2.0a9d7002.svg";